import PresentationContainer from 'react-presentation-container';
import { routeWithParams } from '@/core/router-helpers';
import ROUTES from '@/routes';
import Admin from './Admin.component';

export default PresentationContainer({
  component: Admin,
  controller: function AdminController({ history }) {
    const onScreenPress = (screen) => {
      history.push(routeWithParams(ROUTES.ADMIN, { params: { screen } }));
    };

    return {
      onScreenPress,
    };
  },
});
